import { Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { Chat } from './chat';
import { ChatService } from './chat.service';

@Injectable({
  providedIn: 'root',
})
export class ChatHolderService {
  currentChat = signal<Chat | undefined>(undefined);

  constructor(private chatService: ChatService) {}

  changeChat$(chatId: string) {
    return this.chatService.getChat$(chatId).pipe(
      tap((data) => {
        this.currentChat.set(data.chat);
      })
    );
  }
}
